import React from 'react';
import styles from './PricingPage.module.css';
import DetailSection from './DetailSection';
import FooterPricing from './FooterPricing';
import Background from './Background';
import HeaderPricing from './HeaderPricing';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../store/selectors/authSelectors';
import DetailSectionPublic from './DetailSectionPublic';

const PricingPage: React.FC = () => {
    const user = useSelector(selectUser);

    return (
        <div className={styles.pricingPage}>
            <Background />
            <HeaderPricing />
            {user?.email ? <DetailSection /> : <DetailSectionPublic />}
            <FooterPricing />
        </div>
    );
};

export default PricingPage;
